import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { urls } from 'Config'

import { useFeatureFlags } from '@/providers/featureFlags/FeatureFlagsProvider'
import useFeatureFlagsReady from '@/hooks/useFeatureFlagsReady'
import useDynamicLogo from '@/hooks/useDynamicLogo'
import resolveLogoUrl from '@/utils/resolveLogoUrl'
import { FEATURE_FLAG_KEYS } from '@/constants'
import { ROOT } from '@/routes'

// `ZenQMS` is a never-translate brand term, so the alt text is not a translated message.
const LOGO_ALT = 'ZenQMS'

const LoginLogo = () => {
  const featureFlags = useFeatureFlags()
  const isFlagsReady = useFeatureFlagsReady()
  // `undefined` (flag archived, SDK unreachable) must read as off: keep the bundled logo.
  const isNewLogoEnabled = Boolean(featureFlags[FEATURE_FLAG_KEYS.ROLLOUT_NEW_BRANDING_LOGO])
  const {
    src, imageRef, onLoad, onError, isRemote, isLoaded,
  } = useDynamicLogo(resolveLogoUrl(urls.logoFull), isFlagsReady && isNewLogoEnabled)

  // Both logos stay hidden until the flag has resolved and, when it is on, the remote image has
  // decoded - otherwise the bundled logo paints first and visibly swaps a moment later.
  const isPending = !isFlagsReady || (isRemote && !isLoaded)

  return (
    <div className="logo-wrapper">
      <Link
        to={ROOT}
        className={clsx({
          'logo-link--pending': isPending,
          'logo-link--remote': isRemote,
        }) || undefined}
      >
        {isRemote && <img ref={imageRef} src={src} onLoad={onLoad} onError={onError} alt={LOGO_ALT} />}
      </Link>
    </div>
  )
}

export default LoginLogo
